import { useRef, useState } from "react";
import { IconPlayerPauseFilled } from "@tabler/icons-react";
import { IconPlayerPlayFilled } from "@tabler/icons-react";
import { tracks } from "../data/tracks.js";
import { useLang } from "../context/LanguageContext.jsx";

export default function AudioPlayer() {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
  const [currentTrack, setCurrentTrack] = useState(tracks[0]);
  const { lang } = useLang();

  const togglePlay = () => {
    if (isPlaying) audioRef.current.pause();
    else audioRef.current.play();
    setIsPlaying(!isPlaying);
  };

  const handleNextTrack = () => {
    const nextIndex = (currentTrackIndex + 1) % tracks.length;
    setCurrentTrackIndex(nextIndex);
    setCurrentTrack(tracks[nextIndex]);
    setIsPlaying(false);
  };

  const handlePreviousTrack = () => {
    const prevIndex =
      currentTrackIndex === 0 ? tracks.length - 1 : currentTrackIndex - 1;
    setCurrentTrackIndex(prevIndex);
    setCurrentTrack(tracks[prevIndex]);
    setIsPlaying(false);
  };

  const handleTrackChange = () => {
    if (isPlaying) {
      audioRef.current.play();
    }
  };

  return (
    <div className="bar-player">
      <audio
        ref={audioRef}
        src={currentTrack.src}
        onEnded={() => setIsPlaying(false)}
        onChange={handleTrackChange}
      />

      {/* LEFT: TRACK NAME */}
      <div className="track-name" title={currentTrack.title}>
        {currentTrack.title}
      </div>

      {/* CENTER: ANIMATION */}
      <div className={`equalizer ${isPlaying ? "playing" : ""}`}>
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>

      {/* RIGHT: CONTROLS */}
      <div className="controls">
        {lang == "ar" ? (
          <div className="controlBtn" onClick={handleNextTrack}>
            <img src="./images/next.png" alt="Next" />
          </div>
        ) : (
          <div className="controlBtn" onClick={handlePreviousTrack}>
            <img src="./images/prev.png" alt="Previous" />
          </div>
        )}

        <div
          className="controlBtn"
          style={{ width: "max-content" }}
          onClick={togglePlay}
        >
          {isPlaying ? (
            <IconPlayerPauseFilled size={22} />
          ) : (
            <IconPlayerPlayFilled size={22} />
          )}
        </div>

        {lang === "ar" ? (
          <div className="controlBtn" onClick={handleNextTrack}>
            <img src="./images/prev.png" alt="Next" />
          </div>
        ) : (
          <div className="controlBtn" onClick={handlePreviousTrack}>
            <img src="./images/next.png" alt="Next" />
          </div>
        )}

        {/* <div className="controlBtn" onClick={handleNextTrack}>
          <img src="./images/next.png" alt="Next" />
        </div> */}
      </div>
    </div>
  );
}
